/* tslint:disable */

export class DecisionServiceVersion {
		Id: number;
		DecisionServiceId: number;
		DecisionName: string;
		VersionNumber: number;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/DecisionServiceVersion.ts